<app-modal-header [hasClose]='true' [title]="'ADICIONAR EVIDÊNCIA'" (handleClose)="close()"></app-modal-header>

<mat-dialog-content class="content-dialog">

  @if (evidencesForm) {
    <form [formGroup]="evidencesForm">
      <!-- <h4 style="text-align: left;">{{performance_standard_description}}</h4><br> -->
      <mat-form-field>
        <mat-select formControlName="performance_standard_id" placeholder="Padrão de Desempenho">
          @for (item of performance_standards; track item) {
            <mat-option [value]="item.id">
              {{competence_element_code}}.{{item.code}} - {{item.description}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput formControlName="description" type="text" placeholder="Evidência" required>
        @if (evidencesForm.get('description').errors && evidencesForm.get('description').touched) {
          <mat-error>
          {{evidencesForm.get('description').errors['message']}}</mat-error>
        }
      </mat-form-field>
      <div class='flex'>
        <mat-form-field class="half-input">
          <mat-select matSelect formControlName="capacity_id" placeholder="Capacidade" required>
            @for (capacity of capacities; track capacity) {
              <mat-option [value]="capacity.id">
                C{{capacity.code}} - {{capacity.description}}
              </mat-option>
            }
          </mat-select>
          @if (evidencesForm.get('capacity_id').errors && evidencesForm.get('capacity_id').touched) {
            <mat-error>
            {{evidencesForm.get('capacity_id').errors['message']}}</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="half-input">
          <!-- <input matInput formControlName="difficulty" type="number" placeholder="Peso" required> -->
          <mat-select matSelect formControlName="difficulty" placeholder="Peso" required>
            @for (item of difficultys; track item) {
              <mat-option [value]="item.value"> {{item.description}} </mat-option>
            }
          </mat-select>
          @if (evidencesForm.get('difficulty').errors && evidencesForm.get('difficulty').touched) {
            <mat-error>
            {{evidencesForm.get('difficulty').errors['message']}}</mat-error>
          }
        </mat-form-field>
      </div>
      <mat-form-field class="half-input">
        <input type="text" [formControl]="myActivityControl" placeholder="Atividade" aria-label="Atividade" matInput
          [matAutocomplete]="autoActivity" (keyup)="validControl()" [disabled]="!filteredOptionsActivity">
          <mat-autocomplete #autoActivity="matAutocomplete" [displayWith]="displayFnActivity" matSelect placeholder="Escolha a Atividade" (optionSelected)="validControl()">
            @for (activity of filteredOptionsActivity | async; track activity) {
              <mat-option [value]="activity">
                {{activity?.description}}
              </mat-option>
            }
          </mat-autocomplete>
          @if (evidencesForm.get('activity_evidence_id').errors && evidencesForm.get('activity_evidence_id').touched) {
            <mat-hint>
            {{evidencesForm.get('activity_evidence_id').errors['message']}}</mat-hint>
          }
        </mat-form-field>
        <div class="profiles-check-area-container">
          <p class="primary-text">Objetos de Conhecimento:</p><br>
          <div class="profiles-check-block">
            @for (knowledge of knowledges; track knowledge) {
              <div class="profiles-check-area">
                <mat-checkbox class="profile-list-item" #knowledgeCheckbox [value]="knowledge.id" [disabled]="disbledCheck"
                  [checked]="checkKnowledgeObject(knowledge.id)"><span [title]="knowledge.code">{{sigla(knowledge.code)}}</span> - {{knowledge.description}}</mat-checkbox>
                </div>
              }
            </div>
          </div>
        </form>
      }

    </mat-dialog-content>

    <div class="modal-footer">
      <button type="button" id="modalApplyBtn" mat-raised-button color="accent" [disabled]="evidencesForm.invalid" (click)="onSubmit()">Salvar</button>
      <!-- <button type="button" mat-raised-button (click)="close()" class="far-left form-btn"></button>
      Cancelar
    </button> -->
  </div>
